



























































































import { defineComponent, reactive, toRefs, PropType, computed, watch, onMounted, ref } from '@vue/composition-api';
import * as Common from "../commons/common"
import { BModal } from 'bootstrap-vue';


export interface Data {
  SheetTypeEnum: Readonly<{Normal: number; Cbt: number; Entrance: number; Practice: number;}>
}

export default defineComponent({
  props: {
    tabNo: {
      type: Number as PropType<number>,
      required: true
    },
  },
  setup (props, context) {

    const modalRef = ref<InstanceType<typeof BModal>>();

    /************************************************************
     * Data
     ************************************************************/

    const state = reactive<Data>({
      SheetTypeEnum: Common.SheetTypeEnum,
    });

    const toFieldEdit = () => {
      if(context.root.$store.state.isDigitalPaper){
        context.root.$router.push(`/teacher_site/digital_paper_field_edit/${context.root.$route.params.sheet_group_key}`).catch(err => {});
      }else{
        context.root.$router.push(`/teacher_site/field_edit/${context.root.$route.params.sheet_group_key}`).catch(err => {});
      }
    }

    const toCorrectImageUpload = () => {
      context.root.$router.push(`/teacher_site/correct_image_upload/${context.root.$route.params.sheet_group_key}`).catch(err => {});
    }

    const toPositionEdit = () => {
      context.root.$router.push(`/teacher_site/position_edit/${context.root.$route.params.sheet_group_key}`).catch(err => {});
    }

    const toScorePositionEdit = () => {
      context.root.$router.push(`/teacher_site/score_position_edit/${context.root.$route.params.sheet_group_key}`).catch(err => {});
    }
    
    const toAnswerImageUpload = () => {
      context.root.$router.push(`/teacher_site/answer_image_upload/${context.root.$route.params.sheet_group_key}`).catch(err => {});
    }

    const toQuestionImageUpload = () => {
      context.root.$router.push(`/teacher_site/question_image_upload/${context.root.$route.params.sheet_group_key}`).catch(err => {});
    }

    const toPracticeFieldEdit = () => {
      context.root.$router.push(`/teacher_site/practice_field_edit/${context.root.$route.params.sheet_group_key}`).catch(err => {});
    }
    
    const toPracticePart1Edit = () => {
      context.root.$router.push(`/teacher_site/practice_part1_edit/${context.root.$route.params.sheet_group_key}`).catch(err => {});
    }

    const modalShown = () => {
      const movieRoot = document.getElementById("movie-root");
      const img = document.createElement("img");
      const timestamp = new Date().getTime()
      img.src = require(`@/assets/gif/movie_field_position_setting.gif`) + "?" + timestamp
      img.style.width = "100%";
      movieRoot.appendChild(img);
    }

    
    return {
      ...toRefs(state),
      modalRef,
      toFieldEdit,
      toCorrectImageUpload,
      toPositionEdit,
      toScorePositionEdit,
      toAnswerImageUpload,
      toQuestionImageUpload,
      modalShown,
      toPracticeFieldEdit,
      toPracticePart1Edit,
    }
  }
});
